export const MAX_PREVIEW_WIDTH = 270;

// In-app preview dimensions
export const IN_APP_PREVIEW_WIDTH = 320;
export const IN_APP_PREVIEW_HEIGHT = 600;

// Mobile preview dimensions
export const MOBILE_PREVIEW_WIDTH = 420;
export const MOBILE_PREVIEW_HEIGHT = 720;
